// document.addEventListener('DOMContentLoaded', function() {
    
//     // Check if the url is hit with a hash.
//     checkUrlAndOpenModal();
    
//     const staffCards = document.querySelectorAll('.staff-block');
    
//     staffCards.forEach(function(card) {
//         const modalId = card.dataset.id;
//         card.addEventListener('click', function () {
//             openModal(modalId);
//         });
//     });
// });

// function checkUrlAndOpenModal() {
//     const modalId = window.location.hash.replace('#', '');
//     if (modalId) {
//         openModal(modalId);
//     }
// }


// function openModal(modalId) {
//     const modalOverlay = document.getElementById(modalId);
//     modalOverlay.style.display = 'flex';
    
//     setTimeout(function() {
//         var staffNameElement = modalOverlay.querySelector('.staff-name');
//         var staffName = staffNameElement.textContent;
//         window.dataLayer = window.dataLayer || [];
//         dataLayer.push({'event': 'view_staff_modal', 'staff_name': staffName});
//     }, 100); 
    
//     modalOverlay.querySelector(".close-icon svg").addEventListener('click', function () {
//         closeModal(modalId);
//     });
    
//     window.location.hash = modalId;
    
//     document.documentElement.style.overflow = 'hidden';
// }

// function closeModal(modalId) {
//     const modalOverlay = document.getElementById(modalId);
//     modalOverlay.style.display = 'none';
    
//     // Use history.pushState() to change the URL without leaving a trailing '#'
//     history.pushState("", document.title, window.location.pathname + window.location.search);
    
//     document.documentElement.style.overflow = 'auto';
// }

const contentButtonBlock = $('.wp-block-alluvium-content-button')

// check block exists on page then run
if(contentButtonBlock.length > 0) {

    // set var for attributes passed by block
    const blockAttr = contentButtonProps;

    // on click check block attributes for _blank target, otherwise redirect current tab
    contentButtonBlock.on('click', function() {
        if (blockAttr.link.opensInNewTab) {
            window.open(blockAttr.link.url, '_blank');
        } else {
            location.href = blockAttr.link.url;
        }
    })
}